import { Button, Stack, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

type SuccessMessageProps = {
  headingText: string;
  subheadingText: string;
  buttonText: string;
  isLoading?: boolean;
  to: string;
  onClick?: MouseEventHandler;
};

export const OrganizationSuccessMessage = (
  props: SuccessMessageProps,
): JSX.Element => {
  const { headingText, subheadingText, buttonText, to, onClick, isLoading } =
    props;

  return (
    <Stack
      spacing={2}
      sx={{
        height: '100%',
        minHeight: '100%',
        flex: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack
        spacing={2}
        sx={{
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <Typography variant="h2" align="center">
          <b>{headingText}</b>
        </Typography>

        <Typography align="center">{subheadingText}</Typography>
      </Stack>

      <Button
        fullWidth
        size="large"
        component={Link}
        to={to}
        onClick={onClick}
        disabled={isLoading}
      >
        {buttonText}
      </Button>
    </Stack>
  );
};
